export default __webpack_public_path__ + "static/media/netsuite.706ce5d3.png";